import React from 'react';

import { Button } from 'primereact/button';
import VisibilityWrapper from 'utils/wrappers/VisibilityWrapper';

import { DropdownObjectType, TreeNode } from '../../types/interfaces';
import AssetCard from '../AssetCard/AssetCard';

interface AssetTabProps {
  assetCardKey: string;
  asset: DropdownObjectType | TreeNode;
  assetOptions: DropdownObjectType[];
  handleEditClick: (asset: TreeNode) => void;
}

const AssetTab: React.FC<AssetTabProps> = ({
  assetCardKey,
  asset,
  assetOptions,
  handleEditClick
}) => {
  return (
    <div>
      <VisibilityWrapper code="assets">
        <AssetCard
          key={assetCardKey}
          assetProps={{
            id: Number((asset as DropdownObjectType).key)
          }}
          withoutDialog
        />
      </VisibilityWrapper>
      {asset !== undefined &&
        asset.key.toString().length > 0 &&
        !assetOptions.some(
          (x) =>
            (asset as DropdownObjectType).key === x.key ||
            (asset as DropdownObjectType).key === x.key
        ) && (
        <div className="flex align-items-center gap-2 task-card__asset-warning">
          <i className="pi pi-exclamation-circle task-card__asset-warning-icon" />
          <span className="font-italic">Объект удалён или неактивен</span>
        </div>
      )}
      {!!(asset as DropdownObjectType).key && (
        <Button
          className="mt-3 asset-card__roles task-card__asset-edit-btn"
          label="Изменить"
          type="button"
          icon="pi pi-pencil"
          rounded
          outlined
          onClick={() => handleEditClick(asset as TreeNode)}
        />
      )}
    </div>
  );
};

export default AssetTab;
